<div class="admin-modal">
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <i class="fa fa-times close-btn" (click)="cancel()"></i>
  </div>

  <div class="modal-body">
    <div class="panel panel-default">
      <div class="panel-heading">Search:</div>
      <div class="panel-body">

        <div class="form-group">
          <label>User Search:</label>
          <div class="input-group">
            <input type="text" class="form-control"
                   placeholder="Enter keyword to search"
                   autocomplete="off"
                   [(ngModel)]="selectedUser"
                   (ngModelChange)="onSearchChange()">
            <span class="input-group-addon">
              @if (loading) {
<i class="fa fa-spinner fa-pulse"></i>
}
              @if (!loading) {
<i class="fa fa-search"></i>
}
            </span>
          </div>

          @if (showList && userDetailsArr.length > 0) {
<div class="search-dropdown">
            @for (user of userDetailsArr; track $index) {
<a class="search-item" (click)="fillTextbox(user)">
              {{ user }}
            </a>
}
          </div>
}

          @if (noRecords) {
<div class="no-results-badge">
            <i class="fa fa-times"></i> No Records Found
          </div>
}
        </div>

        <div class="action-buttons">
          <button class="btn btn-warning btn-sm" type="button"
                  (click)="switchUser()" [disabled]="switchReset || loading">Switch User</button>
          <button class="btn btn-warning btn-sm" type="button"
                  (click)="reset()" [disabled]="switchReset">Reset</button>
        </div>

      </div>
    </div>
  </div>
</div>
